import { useGet } from '../useFetch';
import { CreResponse } from '../../types/cre';

export const useGetCREProjects = (simulationModel: 'cre' | 'cpm') =>
  useGet<CreResponse<{ id: string; name: string }[]>>(`/cre/projects/`, {
    params: { limit: 1, simulationModel },
  });

export const useGetSimulationModels = () =>
  useGet<{ name: string; shortName: string }[]>(`/cre/simulation-models/`);
